import PasswordInput from "./PasswordInput";
import ValidatedComponent from "./ValidatedComponent";
import LoadingIndicator from "./LoadingIndicator";
import * as userActions from "../actions/user";
import {connect} from "redux-vue";
import Validator from "validatorjs";

const PasswordEditForm = {
  props: ['user', 'app', 'updatePassword'],

  data() {
    return {
      formData: {
        password: "",
        password_confirmation: "",
      },
      formRules: {
        password: "required|min:8",
        password_confirmation: "required|same:password",
      },
      formErrors: null,
      formLabels: {
        password: this.$t('profile_edit_page.new_password_label'),
        password_confirmation: this.$t('profile_edit_page.confirm_password_label'),
      },
    }
  },

  watch: {
    user (nextVal, val) {
      if (val.edit && nextVal.editSuccess) {
        this.formData = {
          password: "",
          password_confirmation: "",
        };
        Snackbar.show({
          text: this.$t('saved'),
          actionText: this.$t('dismiss'),
        });
      }
    }
  },

  methods: {

    /**
     *
     * @param event
     * @returns {Promise<void>}
     */
    async onSubmit(event) {
      event.preventDefault();

      const validation = new Validator(this.formData, this.formRules);

      validation.setAttributeFormatter((attribute) =>
        this.formLabels[attribute].toLowerCase()
      );

      if (validation.passes()) {
        this.formErrors = null;
        await this.updatePassword(this.formData);

        if (this.user.editError) {
          this.formErrors = this.user.editError.response.data.errors;
        }
      } else {
        this.formErrors = validation.errors.all();
      }

    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <form onSubmit={this.onSubmit}>
        <div class="p-3 lg:p-12 lg:pr-0">
          <p class="font-bold text-base mb-5">
            {this.$t('profile_edit_page.reset_password')}
          </p>

          <div class="lg:w-3/12">
            <div class="mb-4">
              <label class="block text-gray-700 text-sm mb-2" for="password">
                {this.formLabels.password}
              </label>
              <ValidatedComponent
                name="password"
                errors={this.formErrors}
                renderComponent={classname => (
                  <PasswordInput
                    v-model={this.formData.password}
                    classname={classname}
                  />
                )}
              />
            </div>
            <div class="mb-8 lg:mb-4">
              <label class="block text-gray-700 text-sm mb-2" for="password_confirmation">
                {this.formLabels.password_confirmation}
              </label>
              <ValidatedComponent
                name="password_confirmation"
                errors={this.formErrors}
                renderComponent={classname => (
                  <PasswordInput
                    id="password_confirmation"
                    v-model={this.formData.password_confirmation}
                    classname={classname}
                  />
                )}
              />
            </div>
          </div>

          <div class="flex flex-col lg:flex-row items-start lg:items-center mt-4 lg:my-10">
            <button
              class="px-3 lg:px-5 py-2 lg:py-3 mr-3 lg:mr-5 mb-3 lg:mb-0 rounded-full bg-action hover:bg-action-dark focus:outline-none text-base text-white"
              type="submit"
              disabled={this.user.edit}
            >
              {this.user.edit && <LoadingIndicator/>}
              {this.user.edit || (
                <fragment>
                  {this.$t('profile_edit_page.save_changes')}
                  <i class="mdi mdi-arrow-right ml-5"></i>
                </fragment>
              )}
            </button>
            <button type="button" class="focus:outline-none rounded-full text-blue-600 font-bold px-3 lg:px-5 p-2 lg:p-3 text-xs lg:text-base uppercase">
              {this.$t('profile_edit_page.cancel')}
            </button>
          </div>
        </div>
      </form>
    )
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    app: state.app,
  };
}

function mapActionToProps(dispatch) {
  return {
    updatePassword: async (data) => await dispatch(userActions.updatePassword(data)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(PasswordEditForm);
